/**
 * This function should be used in the `componentDidMount` of your root app.
 * In conjunction with the inlined head for your theme's custom font, this
 * will polyfill `font-display: optional` to bring in a custom font on
 * subsequent views of a site.
 * Source: https://github.com/zachleat/web-font-loading-recipes/blob/master/critical-foft-preload-fallback-optional.js
 */

export default function polyfillFontLoading(font: string, variations: any[]) {
  if (!sessionStorage.customFontsLoaded && !('fonts' in document)) {
    return import('fontfaceobserver')
      .then(({ default: FontFaceObserver }) => {
        const fontFaceObservers = variations.map((variation) => {
          const observer = new FontFaceObserver(font, variation);

          return observer.load();
        });

        return (
          Promise.all(fontFaceObservers)
            .then(() => {
              sessionStorage.customFontsLoaded = true;
            })
            // Fail gracefully, polyfill for older browsers
            .catch(
              /* istanbul ignore next */
              (e) => console.error(`Unable to load ${font}`, e)
            )
        );
      })
      .catch(
        /* istanbul ignore next */
        (e) => console.error('unable to load font-face-observer', e)
      );
  }
}
